<template>
  <!-- Footer -->
  <section class="footer-six footer-nine">
    <div class="footer-six-bg footer-nine-bg">
      <img src="@/assets/img/bg/footer-bg.png" alt="" />
    </div>
    <div class="container">
      <div class="footer-six-top footer-nine-top">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="footer-six-right">
              <div class="footer-send-mail">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Subscribe to Get Updates"
                />
                <a href="javascript:void(0);">Send mail</a>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12">
            <div class="footer-six-center foot-nine-list">
              <div class="footer-six-center-content">
                <h6>Our Total Visitors</h6>
                <a href="javascript:void(0);">4,56,6597</a>
              </div>
              <div class="footer-six-center-content">
                <h6>Need live support?</h6>
                <a href="javascript:void(0);">listee@example.com</a>
              </div>
              <div class="footer-six-center-content">
                <h6>Toll Free Customer Care</h6>
                <a href="javascript:void(0);">+91 26447 99875</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row position-relative">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="foot-nine-logo">
            <router-link to="index-9"
              ><img src="@/assets/img/footer-logo-nine.svg" alt=""
            /></router-link>
            <p>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45 BC,
              making it over 2000 years old. Richard...
            </p>
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-sm-12">
          <div class="footer-six-top-list">
            <h4>Discover</h4>
            <ul>
              <li><a href="javascript:void(0);">Chicago</a></li>
              <li><a href="javascript:void(0);">Los Angeles</a></li>
              <li><a href="javascript:void(0);">Miami</a></li>
              <li><a href="javascript:void(0);">New York</a></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-sm-12">
          <div class="footer-six-top-list">
            <h4>Lists by Category</h4>
            <ul>
              <li><a href="javascript:void(0);">Apartments</a></li>
              <li><a href="javascript:void(0);">Condos</a></li>
              <li><a href="javascript:void(0);">Houses</a></li>
              <li><a href="javascript:void(0);">Offices</a></li>
              <li><a href="javascript:void(0);">Retail</a></li>
              <li><a href="javascript:void(0);">Villas</a></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-sm-12">
          <div class="footer-six-top-list">
            <h4>Quick Links</h4>
            <ul>
              <li><router-link to="about">About Us</router-link></li>
              <li>
                <router-link to="terms-condition"
                  >Terms & Conditions</router-link
                >
              </li>
              <li>
                <router-link to="privacy-policy">User’s Guide</router-link>
              </li>
              <li><router-link to="contact">Support Center</router-link></li>
              <li><router-link to="about">Press Info</router-link></li>
              <li><router-link to="contact">Contact Us</router-link></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-sm-12">
          <div class="social-icon-six social-icon-nine">
            <h3>Follow us on</h3>
            <ul>
              <li>
                <a href="javascript:void(0);" target="_blank"
                  ><i class="fab fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" target="_blank"
                  ><i class="fab fa-twitter"></i>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" target="_blank"
                  ><i class="fab fa-instagram"></i
                ></a>
              </li>
              <li>
                <a href="javascript:void(0);" target="_blank"
                  ><i class="fab fa-linkedin-in"></i
                ></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <hr class="custom-line foot-nine-line" />
      <div class="footer-six-bottom pt-0">
        <p class="mb-0">© 2023 Listee. All Rights Reserved.</p>
        <div class="footer-six-center-list">
          <ul>
            <li><router-link to="index-6"> Home</router-link></li>
            <li><a href="javascript:void(0);"> Site Map</a></li>
            <li>
              <router-link to="privacy-policy"> Privacy policy</router-link>
            </li>
            <li>
              <router-link to="privacy-policy"> Cookie Policy</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <!-- /Footer -->
</template>
